module.exports = __webpack_public_path__ + "img/p4-c1-p4.cb3eafc2.jpg";